import { Box } from '@mui/material';
import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';

type SPACING = [0, 1, 2, 3, '3-half', 4, 5];

type SpacerProps = StructuredContentDocument<{
  spacing: SPACING[number];
}>;

export const Spacer = ({ props }: SpacerProps) => {
  const { spacing } = props;

  return <Box sx={{ marginBottom: spacing }} />;
};
